(function () {
  // Reveal the games scoreboard once it scrolls into view (duck splash etc.)
  var gamesBlock = document.querySelector('.quaich-games-block');
  if (gamesBlock && 'IntersectionObserver' in window) {
    var gamesObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          gamesBlock.classList.add('is-in');
          gamesObs.disconnect();
        }
      });
    }, { threshold: 0.3 });
    gamesObs.observe(gamesBlock);
  } else if (gamesBlock) {
    gamesBlock.classList.add('is-in');
  }

  // Sticky booking bar — show once the hero has scrolled out of view, hide when
  // the hero is back on screen.
  var stickybar = document.querySelector('[data-quaich-stickybar]');
  var hero = document.querySelector('.quaich-hero');
  if (stickybar && hero && 'IntersectionObserver' in window) {
    stickybar.hidden = false;
    var heroObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        stickybar.classList.toggle('is-visible', show);
        stickybar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
    heroObs.observe(hero);
  }

  // Duplicate gallery slides so the marquee loops seamlessly.
  var track = document.querySelector('[data-gallery-track]');
  if (track && track.children.length) {
    var clone = function () {
      Array.prototype.slice.call(track.children).forEach(function (slide) {
        track.appendChild(slide.cloneNode(true));
      });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(clone, { timeout: 2000 });
    } else {
      setTimeout(clone, 120);
    }
  }
})();
